import { get as _get, has as _has } from "lodash-es";
import { FETCH_UPDATES_SUCCESS, FETCH_UPDATES_FAIL } from "../actions/sync";
import {
  FETCH_USER_FAIL,
  FETCH_USER_SUCCESS,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  REGISTER_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  CLEAR_CACHE_SUCCESS,
  UPDATE_USER_LOCAL,
  CLEAR_CACHE_FAIL,
} from "../actions/user";

const initialState = {};

export default function user(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_SUCCESS: {
      return {
        ...action.payload.data,
        isAuthenticated: true,
      };
    }

    case FETCH_USER_FAIL: {
      if (_get(action, "error.response.status") === 401) {
        if (state.isAuthenticated) {
          return { ...state, loadLoginModalService: true };
        }
        return { isAuthenticated: false };
      }

      return state;
    }

    case UPDATE_USER_LOCAL: {
      return { ...state, ...action.data };
    }

    case FETCH_UPDATES_SUCCESS: {
      if (action.payload.data.user) {
        return { ...state, ...action.payload.data.user };
      }

      return state;
    }

    case FETCH_UPDATES_FAIL: {
      if (_get(action, "error.response.status") === 401) {
        return { ...state, loadLoginModalService: true };
      }
      return state;
    }

    case UPDATE_USER_SUCCESS: {
      return { ...state, ...action.payload.data };
    }

    case UPDATE_USER_FAIL: {
      // TODO: add rollback
      return state;
    }

    case LOGIN_USER_SUCCESS:
    case REGISTER_USER_SUCCESS: {
      const { response } = action.payload.data;

      if (_has(response, "user.id")) {
        return {
          ...response.user,
          isAuthenticated: true,
        };
      }

      return state;
    }

    case LOGOUT_USER_SUCCESS:
      return {
        ...initialState,
        isAuthenticated: false,
      };

    case CLEAR_CACHE_SUCCESS:
      return {
        ...action.payload.data,
        isAuthenticated: true,
      };

    case CLEAR_CACHE_FAIL: // fail user fetch
      if (_get(action, "error.response.status") === 401) {
        return { isAuthenticated: false };
      }
      return state;

    default:
      return state;
  }
}
